import React from "react";
import { ShieldCheckIcon } from "lucide-react";
import { Accent, Container, H2 } from "./ui";
import { guarantee } from "../data/content";
export function GuaranteeSection() {
  return <section className="bg-white py-12 md:py-16" data-id="element-69" data-mp="9umkd36mq8ck">
      <Container data-id="element-70" data-mp="9t1mb3l3w79y">
        <div className="mx-auto flex max-w-[880px] flex-col items-center gap-6 rounded-2xl border-2 border-petrol bg-sage p-6 text-center sm:p-10 md:flex-row md:gap-10 md:text-left" data-id="element-71" data-mp="9wphe76791qs">
          <div className="flex h-32 w-32 shrink-0 flex-col items-center justify-center rounded-full bg-petrol text-white md:h-36 md:w-36" data-id="element-72" data-mp="jsafhu85dhv9">
            <ShieldCheckIcon className="h-8 w-8" aria-hidden="true" data-id="element-73" data-mp="sl49kxs96lt6" />
            <span className="mt-1 font-display text-4xl font-extrabold leading-none" data-id="element-74" data-mp="smxd447kkpwy">{guarantee.days}</span>
            <span className="text-[11px] font-semibold uppercase tracking-[0.16em]" data-id="element-75" data-mp="xlrwb79g8ghl">Day guarantee</span>
          </div>
          <div data-id="element-76" data-mp="17hv7t3q6xrh7">
            <H2 className="text-[clamp(28px,4vw,44px)]" data-id="element-77" data-mp="17hbslurxdh6v">
              Try the kit with a <Accent data-id="element-78" data-mp="25rnjh0sl8ott">10-day money-back guarantee</Accent>
            </H2>
            <p className="mt-4 text-base text-ink sm:text-lg" data-id="element-79" data-mp="25puctlhz64lt">{guarantee.text}</p>
          </div>
        </div>
      </Container>
    </section>;
}